import React, { useContext, useState , useEffect} from "react";
import { TranslatorContext } from "../../context/Translator";
import { useDolar } from "../../context/DolarContext";
import { Dropdown, Tab, Tabs, Form, Button } from "react-bootstrap";
import Swal from 'sweetalert2';
import cuotaspagadas from "../../assets/data/cuotaspagadas.json";
import { ButtonComponent } from "../elements";

import khipuLogo from "../../assets/images/khipu.png";
import webpayLogo from "../../assets/images/webpay.png";
import getnetLogo from "../../assets/images/Logo_WebCheckout_Getnet.svg";
import {getGira, cuotasAlumno, registrarPagosWebpay, registrarPagosKhipu, registrarPagosGetnet, cargarDocumentoApoderado, obtenerDocumentosApoderado, eliminarDocumentoApoderado, descargarDocumentoApoderado} from "../../api/giras.ts";
import { descargarArchivo} from "../../api/mantenedores.ts"; 
import { fetchConToken } from "../../utils/fetch.ts";
import paymentMethods, { paymentCommissions } from '../../config/paymentMethods';

export default function MisPagosGiraComponent({cuotas, gira, docsGira, aluId, girId}) {

    const { t } = useContext(TranslatorContext)
    const { dolar, loading: dolarLoading, error: dolarError } = useDolar();
    const [selectedCuotas, setSelectedCuotas] = useState([]);
    const [totalMonto, setTotalMonto] = useState(0);
    
    // Función helper para formatear moneda según el tipo de gira (inversa al ListadoUsuarios)
    const formatearMonedaApoderado = (monto) => {
        if (!monto) return '$0';
        
        // Si la gira es en dólares, mostrar el valor en dólares directamente
        if (gira?.gir_pagodolares?.data[0]) {
            const montoEnDolares = monto * dolar;
            return `$${monto.toFixed(2)}`;
        }
        
        // Si la gira es en pesos chilenos, mostrar directamente
        return `$${monto.toLocaleString('es-CL')}`;
    };

     // Función helper para formatear moneda según el tipo de gira
    const formatearMoneda = (monto) => {
        if (!monto) return '0';
        
        // Si la gira es en dólares, mostrar conversión
        if (gira?.gir_pagodolares?.data[0]) {
            const montoEnDolares = monto;
            return `US$${montoEnDolares.toFixed(2)}`;
        } else {
            return `$${monto.toLocaleString('es-CL')}`;
        }
    };
    
    const [cuotasAlumno, setCuotasAlumno] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // Estado para el método de pago seleccionado
    const [multasModificadas, setMultasModificadas] = useState({});
    const [documentosGira, setDocumentosGira] = useState([]);
    const [documentosApoderado, setDocumentosApoderado] = useState([]);
    const [montoBase, setMontoBase] = useState(0); // Monto sin comisión
    const [comision, setComision] = useState(0); // Comisión calculada
    const [nuevoDocumento, setNuevoDocumento] = useState({
        tipo: '',
        archivo: null
    });

    const tiposDocumentos = [
        { id: 'permiso_notarial', nombre: 'Permiso Notarial' },
        { id: 'documento_viaje', nombre: 'Documento de Viaje (Carnet o Pasaporte)' },
        { id: 'receta_medica', nombre: 'Receta Médica o Certificado Médico' }
    ];

    // Métodos de pago habilitados
    const enabledMethods = Object.entries(paymentMethods)
      .filter(([_, enabled]) => enabled)
      .map(([method]) => method);

    // Función para obtener la comisión según el método de pago
    const obtenerComision = (metodo) => {
      if (!metodo) return 0;
      return paymentCommissions[metodo] || 0;
    };

    // Función para calcular la comisión
    const calcularComision = (monto, porcentaje) => {
      return (monto * porcentaje) / 100;
    };

    // Función para formatear fecha en formato dd/mm/yyyy HH:mm
    const formatearFecha = (fecha) => {
      if (!fecha) return '';
      const date = new Date(fecha);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const anio = date.getFullYear();
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
      return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
    };

    useEffect(() => {
      
      
       const sumaTotalCuotas = cuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);
       
    const totalCuotasPagadas = cuotas.filter(cuota => cuota.cou_fpago) // Solo cuotas pagadas (cou_fpago no nulo)
                                        .reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);
      
      const nuevasMultas = {};
      for (let i = 0; i < cuotas.length; i++) {
        const cuota = cuotas[i];
        if(i > 0){
          
          nuevasMultas[cuota.cuo_id] =cuota.multa;
        }else{
           nuevasMultas[cuota.cuo_id] = 0;
        }  
        
      }
      setMultasModificadas(nuevasMultas);
      setCuotasAlumno(cuotas) 
     
      setDocumentosGira(docsGira);

    }, [cuotas, docsGira]);

    // useEffect para cargar documentos del apoderado
    useEffect(() => {
      if (aluId && girId) {
        obtenerDocumentosApoderado(aluId, girId).then((docs) => {
          if (!docs.error && Array.isArray(docs)) {
            setDocumentosApoderado(docs);
          }
        }).catch((error) => {
          console.error('Error al cargar documentos del apoderado:', error);
        });
      }
    }, [aluId, girId]);

  
    


    const handleCheckboxChange = (cuota) => {
         const isSelected = selectedCuotas.includes(cuota.cuo_id);
    let newSelectedCuotas;
    let newTotalMonto;
    let multa  = 0;
    multa = multasModificadas[cuota.cuo_id];

    // Obtener las cuotas pendientes (no pagadas)
    const cuotasPendientes = cuotasAlumno.filter((c) => !c.cou_fpago);

    // Ordenar las cuotas pendientes por el número de cuota (o el campo que corresponda)
    // Si ya están ordenadas en el array, puedes omitir este paso

    // Encontrar el índice de la cuota actual en las cuotas pendientes
    const indexCuota = cuotasPendientes.findIndex(c => c.cuo_id === cuota.cuo_id);

    // Si se está seleccionando (no deseleccionando)
    if (!isSelected) {
        // Solo se puede seleccionar si todas las anteriores ya están seleccionadas
        const cuotasPrevias = cuotasPendientes.slice(0, indexCuota);
        const todasPreviasSeleccionadas = cuotasPrevias.every(c => selectedCuotas.includes(c.cuo_id));
        if (!todasPreviasSeleccionadas) {
            setTimeout(() => {
                const checkbox = document.querySelector(`input[data-cuo_id="${cuota.cuo_id}"]`);
                if (checkbox) checkbox.checked = false;
            }, 0);

            Swal.fire({
                icon: "warning",
                text: "Debe seleccionar las cuotas en orden.",
            });
            return;
        }
    } else {
        // Si se está deseleccionando, también deselecciona todas las posteriores
        const cuotasPosteriores = cuotasPendientes.slice(indexCuota + 1);
        newSelectedCuotas = selectedCuotas.filter(
            cuo_id => cuo_id !== cuota.cuo_id && !cuotasPosteriores.some(c => c.cuo_id === cuo_id)
        );
        // Recalcula el total
        let recalculoTotal = 0;
        newSelectedCuotas.forEach(cuo_id => {
            const c = cuotasAlumno.find(cu => cu.cuo_id === cuo_id);
            recalculoTotal += Number(c.cou_valor + (multasModificadas[cuo_id] || 0));
        });
        setSelectedCuotas(newSelectedCuotas);
        setMontoBase(recalculoTotal);
        
        // Recalcular comisión si hay método de pago seleccionado
        if (selectedPaymentMethod) {
          const porcentajeComision = obtenerComision(selectedPaymentMethod);
          const comisionCalculada = calcularComision(recalculoTotal, porcentajeComision);
          setComision(comisionCalculada);
          setTotalMonto(recalculoTotal + comisionCalculada);
        } else {
          setComision(0);
          setTotalMonto(recalculoTotal);
        }
        return;
    }

    // Selección normal
    newSelectedCuotas = [...selectedCuotas, cuota.cuo_id];
    newTotalMonto = totalMonto + Number(cuota.cou_valor + multa);

    setSelectedCuotas(newSelectedCuotas);
    setMontoBase(newTotalMonto);
    
    // Recalcular comisión si hay método de pago seleccionado
    if (selectedPaymentMethod) {
      const porcentajeComision = obtenerComision(selectedPaymentMethod);
      const comisionCalculada = calcularComision(newTotalMonto, porcentajeComision);
      setComision(comisionCalculada);
      setTotalMonto(newTotalMonto + comisionCalculada);
    } else {
      setComision(0);
      setTotalMonto(newTotalMonto);
    }
    };

    const handlePaymentMethodSelect = (method) => {
      console.log("Método de pago seleccionado:", method);
      setSelectedPaymentMethod(method); // Actualizar el método de pago seleccionado
      
      // Calcular la comisión basada en el método de pago
      if (montoBase > 0) {
        const porcentajeComision = obtenerComision(method);
        const comisionCalculada = calcularComision(montoBase, porcentajeComision);
        setComision(comisionCalculada);
        setTotalMonto(montoBase + comisionCalculada);
      }
    };

    const handlePay = async () => {
        // Validar que se hayan seleccionado cuotas
        if (!selectedCuotas || selectedCuotas.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Cuotas requeridas",
                text: "Por favor, seleccione al menos una cuota para pagar.",
                confirmButtonText: "Aceptar"
            });
            return;
        }

        // Validar que se haya seleccionado un método de pago
        if (!selectedPaymentMethod) {
            Swal.fire({
                icon: "warning",
                title: "Método de pago requerido",
                text: "Por favor, seleccione un método de pago antes de continuar.",
                confirmButtonText: "Aceptar"
            });
            return;
        }

        // Lógica para procesar el pago
        
        Swal.fire({
                   title: "Procesando...",
                   text: "Por favor, espere...",
                   allowOutsideClick: false,
                   didOpen: () => {
                     Swal.showLoading();
                   }
                 });

        if(selectedPaymentMethod === "Khipu") {
          registrarPagosKhipu(selectedCuotas).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

            const form = document.createElement("form");
            form.action = response.url;
            form.method = "GET";

            
            document.body.appendChild(form);

            form.submit(); 

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );
        } else if(selectedPaymentMethod === "Webpay"){
          registrarPagosWebpay(selectedCuotas, dolar).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });

            const form = document.createElement("form");
            form.action = response.url;
            form.method = "POST";

            const inputToken = document.createElement("input");
            inputToken.type = "hidden";
            inputToken.name = "token_ws";
            inputToken.value = response.token;

            form.appendChild(inputToken);
            document.body.appendChild(form);

            form.submit(); 

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );
        } else if(selectedPaymentMethod === "Getnet"){
          registrarPagosGetnet(selectedCuotas).then((response) => {
            Swal.close();
            Swal.fire({
                title: "Redireccionando al portal de pagos...",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
              console.log("Redireccionando a:", response);
            const form = document.createElement("form");
            form.action = response.url;
            form.method = "GET";

            
            document.body.appendChild(form);
             form.submit(); 

            }).catch((error) => {
                Swal.close();
                Swal.fire({
                    title: "Error",
                    text: "Se ha producido un error al procesar el pago.",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                  });
                console.error(error);
            }
        );
        }       
         
    };

     const calculateMulta = (fechaVencimiento, valorGira, proximaFechaVencimiento = null) => {
    // fechaVencimiento y proximaFechaVencimiento en formato 'dd-mm-yyyy'
    const [day, month, year] = fechaVencimiento.split('-').map(Number);
    const fechaVenc = new Date(year, month - 1, day);

    // Sumar un día para que la multa empiece al día siguiente
    fechaVenc.setDate(fechaVenc.getDate() + 1);
    const fechaActual = new Date(); // fecha actual
    if(fechaActual <= fechaVenc ){
        return 0; // Si la fecha actual es antes o igual a la fecha de vencimiento, no hay multa
    }

    // Determinar hasta cuándo calcular la multa
    let fechaLimite;
    if (proximaFechaVencimiento) {
        const [nextDay, nextMonth, nextYear] = proximaFechaVencimiento.split('-').map(Number);
        fechaLimite = new Date(nextYear, nextMonth - 1, nextDay);
        if(fechaLimite >= fechaActual){
            fechaLimite = new Date(); // Si la próxima cuota es antes o igual a la fecha de vencimiento, no hay multa
        }
    } else {
        fechaLimite = new Date(); // fecha actual si no hay próxima cuota
    }

    // Si la fecha límite es menor o igual a la fecha de inicio de multa, no hay multa
    if (fechaLimite <= fechaVenc) {
        return 0;
    }
   
    if(gira.gir_mulmensual?.data[0]){
        return  Math.floor(valorGira * (gira.gir_porcmulta / 100) ); // 1% por semana
    }else{
         // Calcular semanas completas de atraso
        const diferenciaEnMilisegundos = fechaLimite - fechaVenc;
        const semanasAtraso = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24 * 7));
         if(semanasAtraso === 0){
            return  Math.floor((1)  * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
        }
        return  Math.floor(semanasAtraso * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
    }
   
    };

    const handleDownload = async (fileId, fileName) => {
                      try {
                        const response = await descargarArchivo(fileId, 'pdf');
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName); // Nombre del archivo
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                      } catch (error) {
                        Swal.fire({
                          icon: 'error',
                          text: 'Error al descargar el archivo'
                        });
                      }
              };

    const handleDownloadComprobante = async (downloadUrl, ordenCompra) => {
        try {
            // Realizar la descarga usando fetchConToken que maneja automáticamente la autenticación
            const response = await fetchConToken(downloadUrl.replace('/api/', ''), {}, 'GET');

            if (!response.ok) {
                throw new Error('Error al descargar el comprobante');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Comprobante_${ordenCompra}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            Swal.fire({
                icon: 'success',
                title: 'Descarga exitosa',
                text: 'El comprobante se ha descargado correctamente',
                timer: 2000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Error descargando comprobante:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo descargar el comprobante. Intente nuevamente.'
            });
        }
    };

    const handleDocumentoTipoChange = (e) => {
        setNuevoDocumento({ ...nuevoDocumento, tipo: e.target.value });
    };

    const handleDocumentoArchivoChange = (e) => {
        const file = e.target.files[0];
        setNuevoDocumento({ ...nuevoDocumento, archivo: file });
    };

    const handleCargarDocumento = async () => {
        if (!nuevoDocumento.tipo) {
            Swal.fire({
                icon: 'warning',
                text: 'Por favor selecciona el tipo de documento'
            });
            return;
        }

        if (!nuevoDocumento.archivo) {
            Swal.fire({
                icon: 'warning',
                text: 'Por favor selecciona un archivo'
            });
            return;
        }

        if (documentosApoderado.length >= 10) {
            Swal.fire({
                icon: 'warning',
                text: 'No puedes cargar más de 10 documentos'
            });
            return;
        }

        // Validar que tenga aluId y girId
        if (!aluId || !girId) {
            Swal.fire({
                icon: 'error',
                text: 'No se pudo obtener la información necesaria para cargar el documento'
            });
            return;
        }

        // Mostrar loading
        Swal.fire({
            title: 'Cargando documento...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Enviar archivo a la API
        const resultado = await cargarDocumentoApoderado(aluId, girId, nuevoDocumento.tipo, nuevoDocumento.archivo);

        Swal.close();

        if (resultado.error) {
            Swal.fire({
                icon: 'error',
                text: resultado.msg || 'Error al cargar el documento'
            });
            return;
        }

        // Agregar a la lista local
        const nuevoDocumentoObj = {
            doc_id: resultado.doc_id || Date.now(),
            alu_id: aluId,
            gir_id: girId,
            doc_tipo: nuevoDocumento.tipo,
            doc_nombre: nuevoDocumento.archivo.name,
            file_path: resultado.filePath,
            created_at: new Date().toLocaleString()
        };

        setDocumentosApoderado([...documentosApoderado, nuevoDocumentoObj]);
        setNuevoDocumento({ tipo: '', archivo: null });

        Swal.fire({
            icon: 'success',
            text: 'Documento cargado exitosamente'
        });
        
        Swal.fire({
            icon: 'success',
            text: 'Documento cargado correctamente'
        });
    };

    const handleEliminarDocumento = async (documentoId) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Eliminar de la BD si tiene doc_id
                const doc = documentosApoderado.find(d => d.doc_id === documentoId || d.id === documentoId);
                if (doc && doc.doc_id) {
                    Swal.fire({
                        title: 'Eliminando...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    const resultado = await eliminarDocumentoApoderado(doc.doc_id);
                    Swal.close();
                    
                    if (resultado.error) {
                        Swal.fire({
                            icon: 'error',
                            text: resultado.msg || 'Error al eliminar documento'
                        });
                        return;
                    }
                }
                
                // Eliminar del estado local
                setDocumentosApoderado(documentosApoderado.filter(d => d.doc_id !== documentoId && d.id !== documentoId));
                Swal.fire({
                    icon: 'success',
                    text: 'Documento eliminado exitosamente'
                });
            }
        });
    };

    return (
        <div className="mc-card" >
            <div className="mc-card-header">
                <h4 className="mc-card-title">Pagos</h4>
               
            </div>
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                <Tab eventKey="profile" title="Cuotas Viajes" className="mc-tabpane profile ">
                    <ul className="mc-activity-card-list" style={{ height: '1000px' }}>
                        Proximamente!!
                    </ul>
                 {/*<ul className="mc-activity-card-list" style={{ height: '1000px' }}>
               
                <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                        <th ></th>   
                         <th >Nº Cuota</th>
                         <th >Fecha vencimiento</th>
                         <th >Monto</th>
                         <th >Multa</th>
                         <th >A Pagar</th>
                         <th >Fecha de pago</th>
                         <th >Monto pagado</th>
                         <th >Detalle</th>
                         <th >Comprobante</th>
                        
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {cuotasAlumno.map((cuota, index) => {
                                                
                                                return (
                                                <tr key={cuota.cuo_id}>
                                                    <td>
                                                    {!cuota.cou_fpago && <input type="checkbox"  checked={selectedCuotas.includes(cuota.cuo_id)}  data-cuo_id={cuota.cuo_id} onChange={() => handleCheckboxChange(cuota)} />}
                                                    </td>
                                                    <td title="id">{cuota.cou_ncuota}</td>
                                                    <td title={cuota.cou_festpago}>{cuota.cou_festpago}</td>
                                                    <td title={cuota.cou_valor}>{formatearMoneda(cuota.cou_valor)}</td>
                                                    <td title="multa">
                                                      {!cuota.cou_fpago ?
                                                       formatearMoneda(multasModificadas[cuota.cuo_id]) :
                                                       formatearMoneda(cuota.cou_multa || 0)}
                                                       
                                                      </td> 
                                                    <td title="apagar">  
                                                        {cuota.cou_fpago ?
                                                          formatearMoneda(Math.floor(cuota.cou_valor + (cuota.cou_multa || 0))) : formatearMoneda(Math.floor(cuota.cou_valor + multasModificadas[cuota.cuo_id]))} </td> }
                                                    <td title={cuota.cou_fpago}>{cuota.cou_fpago}</td>
                                                    <td title={cuota.cou_montopagado}>{formatearMoneda(cuota.cou_montopagado || 0)}</td>
                                                    <td title={cuota.cou_detalle}>
                                                    {cuota.cou_detalle}
                                                    {cuota.web_id !== null && <p>Pago con Webpay</p>}
                                                    {cuota.khi_id !== null && <p>Pago con Khipu</p>}
                                                   {enabledMethods.includes('getnet') && (cuota.get_id !== null && <p>Pago con Getnet</p>)}
                                                   
                                                  
                                                   {gira?.gir_pagodolares?.data[0] && cuota.cou_valordolar && cuota.cou_fpago && (
                                                       <p className="text-muted">
                                                           <small>Dólar: ${cuota.cou_valordolar.toLocaleString('es-CL')}</small>
                                                       </p>
                                                   )}
                                                    </td>
                                                    <td title="comprobante">
                                                        {cuota.tiene_comprobante && cuota.comprobante ? (
                                                            <div className="comprobante-info" style={{textAlign: 'center'}}>
                                                                <button 
                                                                    type="button" 
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => handleDownloadComprobante(cuota.comprobante.download_url, cuota.comprobante.orden_compra)}
                                                                    title="Descargar comprobante de pago"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '5px',
                                                                        padding: '5px 10px',
                                                                        fontSize: '12px',
                                                                        margin: '0 auto'
                                                                    }}
                                                                >
                                                                    <i className="material-icons" style={{fontSize: '16px'}}>download</i>
                                                                    Comprobante
                                                                </button>
                                                                <div className="mt-1" style={{fontSize: '10px'}}>
                                                                    <small className="text-muted">
                                                                        {cuota.comprobante.orden_compra}
                                                                    </small>
                                                                    {cuota.comprobante.es_pago_multiple && (
                                                                        <div style={{color: '#17a2b8'}}>
                                                                            <small>
                                                                                <i className="material-icons" style={{fontSize: '10px', verticalAlign: 'middle'}}>info</i>
                                                                                Pago múltiple ({cuota.comprobante.cuotas_incluidas.length} cuotas)
                                                                            </small>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <span className="text-muted" style={{fontSize: '12px'}}>
                                                                {cuota.cou_fpago ? 'No disponible' : '-'}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                                );
                                            })}
                    </tbody>
                 </table>
    
                                            <div className="total-monto">
                        {montoBase > 0 && (
                            <>
                                <div className="mb-3 p-3 border rounded">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>Monto Base:</span>
                                        <strong>{formatearMonedaApoderado(gira?.gir_pagodolares?.data[0] ? montoBase * dolar : montoBase)}</strong>
                                    </div>
                                    {comision > 0 && selectedPaymentMethod && (
                                        <>
                                            <div className="d-flex justify-content-between mb-2 text-warning">
                                                <span>Comisión ({selectedPaymentMethod} {obtenerComision(selectedPaymentMethod)}%):</span>
                                                <strong>{formatearMonedaApoderado(gira?.gir_pagodolares?.data[0] ? comision * dolar : comision)}</strong>
                                            </div>
                                            <hr className="my-2" />
                                        </>
                                    )}
                                    <div className="d-flex justify-content-between">
                                        <h5 className="mb-0">Total a Pagar:</h5>
                                        <h5 className="mb-0 text-success"><strong>{formatearMonedaApoderado(gira?.gir_pagodolares?.data[0] ? totalMonto * dolar : totalMonto)}</strong></h5>
                                    </div>
                                </div>
                                {gira?.gir_pagodolares?.data[0] && totalMonto > 0 && dolar && (
                                    <div className="mb-3">
                                        <p className="text-muted mb-1">
                                            <small>Equivalente:US${Math.round((totalMonto)).toLocaleString('es-CL')} (Dólar: ${dolar.toLocaleString('es-CL')})</small>
                                        </p>
                                        <p className="text-info">
                                            <small><i className="material-icons" style={{fontSize: '14px', verticalAlign: 'middle'}}>info</i> Los pagos se procesarán con el valor del dólar actual</small>
                                        </p>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="payment-methods">
                      <h5>Seleccione Método de Pago</h5>
                      <ul className="payment-methods-list" style={{ display: 'flex', justifyContent: 'space-around' }}>
                        {enabledMethods.includes('webpay') && (
                          <li
                            onClick={() => handlePaymentMethodSelect("Webpay")}
                            style={{
                              cursor: "pointer",
                              border: selectedPaymentMethod === "Webpay" ? "2px solid blue" : "none",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <img
                              src={webpayLogo}
                              alt="Webpay"
                              className="payment-logo"
                              style={{ maxWidth: "260px", height: "60px" }}
                            />
                            <p>Para pago con Tarjeta de crédito selecciona Webpay</p>
                          </li>
                        )}
                        {enabledMethods.includes('getnet') && (
                          <li
                            onClick={() => handlePaymentMethodSelect("Getnet")}
                            style={{
                              cursor: "pointer",
                              border: selectedPaymentMethod === "Getnet" ? "2px solid blue" : "none",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <img
                              src={getnetLogo}
                              alt="Getnet"
                              className="payment-logo"
                              style={{ maxWidth: "260px", height: "50px" }}
                            />
                            <p>Para pago con Tarjeta de crédito o <br/> débito, selecciona Getnet</p>
                          </li>
                        )}
                        {enabledMethods.includes('khipu') && (
                          <li
                            onClick={() => handlePaymentMethodSelect("Khipu")}
                            style={{
                              cursor: "pointer",
                              border: selectedPaymentMethod === "Khipu" ? "2px solid blue" : "none",
                              padding: "5px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <img
                              src={khipuLogo}
                              alt="Khipu"
                              className="payment-logo"
                              style={{ maxWidth: "260px", height: "50px" }}
                            />
                            <p>Para pago con Khipu</p>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <ButtonComponent onClick={handlePay} className="btn btn-primary" >Pagar</ButtonComponent>
                    </div>
                    
                    </ul>*/}
                    
                </Tab> 
                <Tab eventKey="password" title="Documentos" className="mc-tabpane password">
                <ul className="mc-activity-card-list thin-scrolling">
              
                    <div style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #ddd' }}>
                        <h6 className="mc-divide-title mb-4">Cargar Documentos Requeridos</h6>
                        <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '15px' }}>Puedes cargar hasta 10 documentos (Máximo 10MB cada uno)</p>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Tipo de Documento</Form.Label>
                                <Form.Select
                                    value={nuevoDocumento.tipo}
                                    onChange={handleDocumentoTipoChange}
                                    disabled={documentosApoderado.length >= 10}
                                >
                                    <option value="">Seleccionar tipo de documento</option>
                                    {tiposDocumentos.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Archivo (PDF o Imágenes: JPG, PNG)</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    onChange={handleDocumentoArchivoChange}
                                    disabled={documentosApoderado.length >= 10}
                                />
                            </Form.Group>
                            <Button
                                variant="primary"
                                onClick={handleCargarDocumento}
                                disabled={documentosApoderado.length >= 10}
                            >
                                Cargar Documento
                            </Button>
                            <p style={{ fontSize: '0.85rem', marginTop: '0.5rem', color: '#999' }}>
                                Documentos cargados: {documentosApoderado.length}/10
                            </p>
                        </Form>
                    </div>

                    {documentosApoderado.length > 0 && (
                        <div style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #ddd' }}>
                            <h6 className="mc-divide-title mb-4">Mis Documentos Cargados</h6>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {documentosApoderado.map((doc) => (
                                    <div
                                        key={doc.doc_id || doc.id}
                                        style={{
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <div>
                                            <p style={{ margin: 0, fontWeight: 'bold' }}>
                                                {tiposDocumentos.find(t => t.id === (doc.doc_tipo || doc.tipo))?.nombre}
                                            </p>
                                            <p style={{ margin: '5px 0 0 0', fontSize: '0.85rem', color: '#666' }}>
                                                {doc.doc_nombre || doc.nombre}
                                            </p>
                                            <p style={{ margin: '2px 0 0 0', fontSize: '0.8rem', color: '#999' }}>
                                                {formatearFecha(doc.created_at) || formatearFecha(doc.timestamp)}
                                            </p>
                                        </div>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            {doc.doc_id && (
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={() => descargarDocumentoApoderado(doc.doc_id)}
                                                    title="Descargar documento"
                                                >
                                                    <i className='material-icons' style={{ fontSize: '1rem' }}>download</i>
                                                </Button>
                                            )}
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() => handleEliminarDocumento(doc.doc_id || doc.id)}
                                                title="Eliminar documento"
                                            >
                                                <i className='material-icons' style={{ fontSize: '1rem' }}>delete</i>
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
    
                
                </ul>
                </Tab>
                <Tab eventKey="documentosGira" title="Documentos Gira" className="mc-tabpane documentosGira">
                <ul className="mc-activity-card-list thin-scrolling">
                    <div>
                        <h6 className="mc-divide-title mb-4">Documentos de la Gira</h6>
                        <table className="mc-table">
                            <thead className="mc-table-head primary">
                                <tr>
                                    <th>Nombre Archivo</th>
                                    <th>Fecha</th>
                                    <th>Descargar</th>
                                </tr>
                            </thead>
                            <tbody className="mc-table-body even">
                            {documentosGira?.length === 0 ? (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center', color: '#999' }}>
                                        No hay documentos disponibles
                                    </td>
                                </tr>
                            ) : (
                                documentosGira.map((item, index) => (
                                    <tr key={index}>  
                                        <td title="id">
                                        {item.doc_nombre}
                                        </td>
                                        <td title="id">
                                        {formatearFecha(item.fecha_subida)}
                                        </td>   
                                        <td title="id">
                                         <button type='button' className='mc-dropdown-menu' onClick={() => handleDownload(item.fil_id,  item.doc_nombre)}><i className='material-icons'>download</i><span>Descargar</span></button>
                                        </td>  
                                    </tr>
                                ))
                            )}    
                            </tbody>
                        </table>
                    </div>
                
                </ul>
                </Tab>    
            </Tabs>    
           
        </div>
    )
}